(function (){
    'use strict';
    angular.module('Services').service('PromoCodeTableService', PromoCodeTableService);
    PromoCodeTableService.$inject = [
        '$filter',
        '$uibModal',
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$rootScope',
        'toastr',
        'ConfirmationModalFactory',
        '$q'
    ];

    function PromoCodeTableService(
        $filter,
        $uibModal,
        TableLiteFactory,
        $location,
        AffiliateService,
        $rootScope,
        toastr,
        ConfirmationModalFactory,
        $q
    ){
        return function (){
            const role = $rootScope.GlobalProfile.permissionGroup.roles.find(permission => permission.code == 'ROLE_MARKETING_ADMIN' || 'ROLE_COMPANY_ADMIN' || 'ROLE_ADMIN')

            const deleteConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteAdminAccount.MESSAGE',
                code: 'messages.warning.deleteAdminAccount.CODE'
            });
            const promoButton={
                class: 'btn-success',
                label: 'Add Promo code',
                tooltip: 'Report Approvals',
                onClick: function () {
                    showPromoCodeModal()
                    // $location.path('/affiliates-sales/approval-report');
                }
            }
        
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,

                },
                optionAddOns:{
                    buttons: []
                },
                headers:[
                    {
                        label: 'Promo Code',
                        viewName: 'code',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Description',
                        viewName: 'description',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Company',
                        viewName: 'company',
                        filterName:'companyMarketing.name',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            filterBy: 'name',
                            items:[],
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            },
                            refresh: function (model){
                                const defer = $q.defer();
                                let filterItems = this.items;
                                AffiliateService.getAllcompanyPartners(
                                    data=>{
                                        angular.forEach(data.content, (item) => {
                                            filterItems.push(item);
                                        });
                                        defer.resolve();
                                      
                                    },err=>{
                                        defer.reject();
                                    },{size: 30, name: model}
                                )
                                return defer.promise;
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: '$ Discount',
                        viewName: 'discountValue',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: '% Discount',
                        viewName: 'discountPercent',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            item:'discountPercent',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    
                ],
                data:[]
            }

            if(role){
                tableData.optionAddOns.buttons.push(promoButton)
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getAllPromoCode,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err.message);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.code = item.code;
                    item.id = item.id;
                    item.discountValue = $filter('bbaCurrency')(item.discountValue, '') ;
                    item.discountPercent = item.discountPercent;
                    item.company = item.companyMarketing.name;
                    // item.YTDComms = item.commission.total
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit',
                            class: 'btn btn-success',
                            action: row => {
                                $location.path('/affiliates-sales/' +item.id); //: change detailsId to id
                            },
                        },{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: row => {   
                                onDeleteBtnAccountClicked(item.id);
                            }
                        }
                    ]
                    };
                    tableData.data.push(item);
                });
            };


            function onDeleteBtnAccountClicked(item) {
                deleteConfirmationModal.getInstance().result.then(function(cond) {
                    if (!cond) { return; }
                    removeCompany(item)
                });
            }

            function showPromoCodeModal(data) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/affiliateSales/modal/promoCode.html',
                    controller: 'PromoCodeController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        data: function () {
                            return angular.copy(data);
                        }
                    },

                }).result.then(function (data) {
                    // add here    
                    tableActions.sendRequest();
                });
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/PromoCodeTableService.js